import React from "react"
import { Grid } from "@mui/material"
import BSSButton from "../../form/BSSButton"
import __t from "../../../lib/traduzioni"

const FrammentoSubmit = ({methods, classes, onSubmit, gridProps={}, buttonProps={}}) => {
    return (
        <Grid item xs={12} className={classes.formGroupBox} {...gridProps}>
            <BSSButton methods={methods} onClick={onSubmit} {...buttonProps}>
                {__t("tariffe")}
            </BSSButton>            
        </Grid>
    )
}

export default FrammentoSubmit